import { Document } from "../jotai/documents.jotai";

export const checkAproval = (doc: Document) => {
  if (doc.status === "approved") {
    return true;
  }
  return false;
};

export const aprovalRequiredForSignatureCompanies = ["12430"];
